<template>
    <el-dialog :title="isEdit ? '编辑风柜' : '添加风柜'" :visible.sync="visible" width="40%" :before-close="handleCloseDialog">
       <el-form key="cabinetFormRules" label-width="108px" :rules="cabinetFormRules" ref="cabinetForm" :model="cabinetForm" class="fancoil-form">
            <el-form-item label="风柜型号" key="8" prop="fancupboard_model">
                <el-input v-model="cabinetForm.fancupboard_model" :disabled="isEdit" key="fancupboard_model"></el-input>
            </el-form-item>
            <el-form-item label="风柜换热量" key="9" prop="cupboard_heat">
                <el-input v-model.number="cabinetForm.cupboard_heat" key="cupboard_heat">
                    <template slot="append">w</template>
                </el-input>
            </el-form-item>
            <el-form-item label="电机功率" key="10" prop="cupboard_power">
                <el-input v-model.number="cabinetForm.cupboard_power" key="cupboard_power">
                    <template slot="append">w</template>
                </el-input>
            </el-form-item>
            <el-form-item label="备注" key="11" prop="description">
                <el-input v-model="cabinetForm.description" key="description"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submitCabinetForm">确定并保存</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
import Service from '@/api/Service'
export default {
    name: "fancoilform",
    props: ["editData", "visible"],
    data() {
        return {
            // 风柜表单
            cabinetForm: {
                fancupboard_model: '',
                cupboard_heat: '',
                cupboard_power: '',
                description: '',
            },
            
            // 风柜表单验证
            cabinetFormRules: {
                fancupboard_model: [{  required: true, message: '请输入风柜型号', trigger: 'blur' }],
                cupboard_heat: [{ required: true, message: '请输入风柜换热量', trigger: 'blur' },
                                { type: 'number', message: '请输入数字格式', trigger: 'blur' }],
                cupboard_power: [{ required: true, message: '请输入电机功率', trigger: 'blur' },
                                { type: 'number', message: '请输入数字格式', trigger: 'blur' }],
                
            },
            isEdit: false,
        };
    },
    created() {
        this.handleEditData();
    },
    watch: {
        editData(val) {
            this.handleEditData();
        }
    },
    components: {},
    methods: {
        handleEditData() {
            if(!this.editData.OID) {
                this.isEdit = false;
                this.cabinetForm = {};
                return
            }
            this.isEdit = true;
            // 风柜
            let {
                OID, 
                FanCupboardModel, 
                CupboardHeat, 
                CupboardPower, 
                Description,
            } = this.editData
            this.cabinetForm.OID = OID;
            this.cabinetForm.fancupboard_model = FanCupboardModel;
            this.cabinetForm.cupboard_heat = CupboardHeat;
            this.cabinetForm.cupboard_power = CupboardPower;
            this.cabinetForm.description = Description;
            
        },
        handleCloseDialog() {
            this.$refs['cabinetForm'].resetFields();
            this.$emit("handleCloseDialog", false);
        },
        // 保存风柜
        submitCabinetForm() {
            this.$refs['cabinetForm'].validate(async (valid)=> {
                if(valid){
                    let data;
                    if(this.cabinetForm.OID){
                        // 修改风盘
                        data = await Service.editFancupboard(this.cabinetForm)
                    }else{
                        // 添加风盘
                        data = await Service.addFancupboard(this.cabinetForm)
                    }
                    if(data) {
                        this.$message({
                            type: 'success',
                            message: '操作成功!'
                        });
                        this.$emit("handleCloseDialog", true);
                        this.$refs['cabinetForm'].resetFields();
                    }
                } else {
                    return false
                }
            })
        }
    }
};
</script>

<style scoped>
.fancoil-form {
    padding: 0 24px;
}
</style>
